import { Link } from "@repo/ui/navigation";

interface ListItemProps {
  icon: React.ReactNode;
  text: string;
  href?: string;
  className?: string;
}

export const ListItem = ({ icon, text, href, className = "" }: ListItemProps) => (
  <Link
    href={href || "#"}
    className={`flex cursor-pointer items-center gap-3 rounded-md px-2 py-2 ${className}`}
  >
    <span className="text-brand-blue rounded-full bg-gray-100 p-2">{icon}</span>
    <span className="text-brand-blue text-sm">{text}</span>
  </Link>
);
